export enum ShortcutKeys {
  Enter = 'Enter',
  Space = ' ',
  Tab = 'Tab',
  Alt = 'Alt',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  Escape = 'Escape',
  Shift = 'Shift',
}
